import API from "../../Api";
import {
  AddFavRestaurants,
  LocationDetails,
  UpdateUserDetailsPayload,
  UserDetials,
  UserGivenDetail,
} from "./userModels";
import { encryptJson } from "../../utils/react-ec-utils";
import { getCookie } from "../../../helper/cookieHelper";
import { USER_DETAILS, USER_ID } from "../../constants";
import { createRequest } from "../../utils/hmac-utils";
var axios = require("axios");

export async function getUserDetails(userDetails: UserDetials = {}) {
  const userID = getCookie(USER_ID)
  const userDetailsFromCookie = getCookie(USER_DETAILS) || {};
  const payload = {
    customerId: userDetails?.customerId || userID,
    email: userDetails?.email || userDetailsFromCookie?.email || "",
    mobileNumber: userDetails?.mobilePhone || userDetailsFromCookie?.mobilePhone || "",
  };
  console.log('/api/customers/user/profile - Payload:', payload);
  // const encryptedData = encryptJson(payload);
  const hmacRequest = await createRequest(payload);
  return (
    payload.customerId &&
    API({
      method: "post",
      url: `/api/customers/user/profile`,
      data: hmacRequest
        // data: hmacRequest, 
    })
  );
}

export async  function updateLocationDetails(data: LocationDetails) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID, customerLocation:data};
  console.log('/api/customers/user/profile - Payload:', payload);
  // const encryptedData = encryptJson(payload);
    const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/user/profile`,

     data: hmacRequest, 
  });
}
export async function deleteLocation(data: LocationDetails) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID, customerLocation:data};
  console.log('/api/customers/user/profile - Payload:', payload);
  // const encryptedData = encryptJson(payload);
  const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
   //data: {"data":hmacRequest}
     data: hmacRequest, 
  });
}

export async function addFavRestaurant(data: AddFavRestaurants) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID,favoriteMerchantLocationRequest:data};
  console.log('/api/customers/user/profile - Payload:', payload);
  // const encryptedData = encryptJson(payload);
  const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
  // data: {"data":hmacRequest}
      data: hmacRequest,  
  });
}
export function updateUserProfile() {
  return API({
    method: "put",
    url: "/customer/88e97221-feb5-4b35-a615-2f74a2132121/profile",
  });
}

export async function updateEmail(email: string) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID, email:email};
  console.log('/api/customers/user/profile - Payload:', payload);
  // const encryptedData = encryptJson(payload);
const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
     data: hmacRequest,  
    // data: {"data":hmacRequest}
  });
}

// For Promo Subscribed

export async function promoConsent(promo: number) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID, isPromoSubscribed:promo};
  console.log('/api/customers/user/profile - Payload:', payload);
  // const encryptedData = encryptJson(payload);
const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
    // data: encryptedData,
    data: hmacRequest,   
  });
}

// Update user details
export async function updateUserDetails(data: UpdateUserDetailsPayload) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID, ...data, isNewUser: Boolean(data?.isNewUser)};
  console.log("api calling");
  
  // const encryptedPayload = encryptJson(payload);
  const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/user/update`,
     data: hmacRequest,   
    headers: {
      'Content-Type': 'application/json',
        "X-source":"CA"
    }
  });
}
